// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  text-align: center;
}

.title {
  font-size: 50px;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  margin-bottom: 30px;
  font-family: Arial, sans-serif;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.subtitle {
  font-size: 38px;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  margin-bottom: 10px;
  font-family: Arial, sans-serif;  
}


.subtitle-uni {
  font-size: 30px;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  margin-bottom: 30px;
  font-family: Arial, sans-serif;  
}

.description {
  font-size: 15px;
  justify-content: center;
  align-items: center;  
  margin-bottom: 25px;
  font-family: Arial, sans-serif;  
  font-weight: normal;
}

.logo {
  height: 140px;
  margin-bottom: 30px;
}

.opening-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; 
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th,
.table td {
  padding: 10px;
  border: 1px solid #ccc;
  text-align: center;
}

.table th {
  background-color: #f0f0f0;
  font-weight: bold;
}

.table tbody tr:hover {
  background-color: #f9f9f9;
  cursor: pointer;
}

.table tbody tr.selected {
  background-color: #dd5050;
}


.form {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.form input[type="text"],
.form input[type="number"] {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-right: 10px;
}

.form button {
  padding: 8px 16px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.btn-update {
  background-color: #28a745;
}

.btn-delete {
  background-color: #dc3545;
}

.btn-update,
.btn-delete {
  padding: 6px 12px;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.btn-update:hover,
.btn-delete:hover {
  opacity: 0.8;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.title-container {
  text-align: left;
}

.universities-section {
  margin-bottom: 40px;
  margin-top: 50px;
}

.universities-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.divider {
  border: none;
  border-top: 1px solid #ccc;
  margin: 40px 0;
}


.students-section {
  margin-bottom: 40px;
}

.students-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.professional-certificates-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.professional-equivalences-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.companies-section {
  margin-bottom: 40px;
}

.companies-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.buttontab {
  background-color: black;
  color: white;
  padding: 15px 30px;
  margin-right: 20px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 16px;
  border: none;
}

.buttontab.active {
  background-color: grey;
  color: white;
}

.json-section {
  margin: 20px;
  padding: 20px;
  border: 1px solid #ccc;
  white-space: pre-wrap;
  font-family: monospace;
}

/* General styles for lines in table actions */
.line {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

/* General styles for table actions container */
.table-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

/* Styles for each line within the table actions container */
.table-actions .line {
  flex-basis: 100%;
  display: flex;
  justify-content: center;
}

/* Additional styles for forms within each line */
.table-actions .line form.form {
  margin-right: 10px;
}

/* Styles for input fields */
.table-actions .line input[type="number"],
.table-actions .line input[type="date"] {
  margin-right: 10px;
}

/* Styles for buttons */
.table-actions .line button {
  margin-right: 10px;
}

/* Company Portal Styles */
.input-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 10px;
}

.input-container2 {  
  justify-content: center;
  margin-bottom: 10px;
}

.input-container .input-group {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  margin-left: 10px;
}

.input-container label {
  margin-right: 10px;
}

.input-container p {
  margin: 0;
}

.section {
  margin-bottom: 40px;
}

/* Blockchain Integration V2 Styles */
.Json-resource-container {
  margin: 20px;
  padding: 20px;
  border: 1px solid #ccc;
  white-space: pre-wrap;
  font-family: monospace;
}

.side-by-side {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.side-by-side2 {
  display: inline-block;
  margin-left: 5px;
}

.side-by-side-bnumber {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 20px;
}

.square {
  width: 70px;
  height: 70px;
  background-color: #f0f0f0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  font-weight: bold;
  margin-left: 30px;
}

.small-heading {
  font-size: small;
}
.red {
  color: red;
}
.green {
  color: green;
}

.container-bch {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 55vh; 
}

/*Certification Manager */

.container-CertificationManager {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.row-CertificationManager {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.col-CertificationManager {
  margin-right: 20px;
  align-self: flex-start;
}

.label-CertificationManager {
  font-weight: bold;
}

.select-input-CertificationManager {
  width: 200px;
}

.add-button-CertificationManager {
  margin-top: 10px;
}

.frame {
  background-color: #f2f2f2;
  border: 3px solid #007bff;
  padding: 10px;
  margin-top: 30px;
  border-radius: 6px;
}

.frame-content {
  background-color: #fff;
  padding: 4px;
  border-radius: 6px;
  box-shadow: 0 2px 4px #007bff;
}

.red-status {
  color: red;
}
.green-status {
  color: green;
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;AAChC;;;AAGA;EACE,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,cAAc;AAChB;;;AAGA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,8CAA8C;AAC9C;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,eAAe;EACf,2BAA2B;AAC7B;;AAEA,4DAA4D;AAC5D;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;;EAEE,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA,yBAAyB;;AAEzB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd","sourcesContent":[".container {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 20px;\n  text-align: center;\n}\n\n.title {\n  font-size: 50px;\n  justify-content: center;\n  align-items: center;\n  font-weight: bold;\n  margin-bottom: 30px;\n  font-family: Arial, sans-serif;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\n}\n\n.subtitle {\n  font-size: 38px;\n  justify-content: center;\n  align-items: center;\n  font-weight: bold;\n  margin-bottom: 10px;\n  font-family: Arial, sans-serif;  \n}\n\n\n.subtitle-uni {\n  font-size: 30px;\n  justify-content: center;\n  align-items: center;\n  font-weight: bold;\n  margin-bottom: 30px;\n  font-family: Arial, sans-serif;  \n}\n\n.description {\n  font-size: 15px;\n  justify-content: center;\n  align-items: center;  \n  margin-bottom: 25px;\n  font-family: Arial, sans-serif;  \n  font-weight: normal;\n}\n\n.logo {\n  height: 140px;\n  margin-bottom: 30px;\n}\n\n.opening-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh; \n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.table th,\n.table td {\n  padding: 10px;\n  border: 1px solid #ccc;\n  text-align: center;\n}\n\n.table th {\n  background-color: #f0f0f0;\n  font-weight: bold;\n}\n\n.table tbody tr:hover {\n  background-color: #f9f9f9;\n  cursor: pointer;\n}\n\n.table tbody tr.selected {\n  background-color: #dd5050;\n}\n\n\n.form {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 20px;\n}\n\n.form input[type=\"text\"],\n.form input[type=\"number\"] {\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  margin-right: 10px;\n}\n\n.form button {\n  padding: 8px 16px;\n  background-color: #007bff;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.btn-update {\n  background-color: #28a745;\n}\n\n.btn-delete {\n  background-color: #dc3545;\n}\n\n.btn-update,\n.btn-delete {\n  padding: 6px 12px;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.btn-update:hover,\n.btn-delete:hover {\n  opacity: 0.8;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.title-container {\n  text-align: left;\n}\n\n.universities-section {\n  margin-bottom: 40px;\n  margin-top: 50px;\n}\n\n.universities-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 20px;\n}\n\n.divider {\n  border: none;\n  border-top: 1px solid #ccc;\n  margin: 40px 0;\n}\n\n\n.students-section {\n  margin-bottom: 40px;\n}\n\n.students-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 20px;\n}\n\n.professional-certificates-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 20px;\n}\n\n.professional-equivalences-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 20px;\n}\n\n.companies-section {\n  margin-bottom: 40px;\n}\n\n.companies-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 20px;\n}\n\n.buttontab {\n  background-color: black;\n  color: white;\n  padding: 15px 30px;\n  margin-right: 20px;\n  border-radius: 20px;\n  cursor: pointer;\n  font-size: 16px;\n  border: none;\n}\n\n.buttontab.active {\n  background-color: grey;\n  color: white;\n}\n\n.json-section {\n  margin: 20px;\n  padding: 20px;\n  border: 1px solid #ccc;\n  white-space: pre-wrap;\n  font-family: monospace;\n}\n\n/* General styles for lines in table actions */\n.line {\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n}\n\n/* General styles for table actions container */\n.table-actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n\n/* Styles for each line within the table actions container */\n.table-actions .line {\n  flex-basis: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n/* Additional styles for forms within each line */\n.table-actions .line form.form {\n  margin-right: 10px;\n}\n\n/* Styles for input fields */\n.table-actions .line input[type=\"number\"],\n.table-actions .line input[type=\"date\"] {\n  margin-right: 10px;\n}\n\n/* Styles for buttons */\n.table-actions .line button {\n  margin-right: 10px;\n}\n\n/* Company Portal Styles */\n.input-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin-bottom: 10px;\n}\n\n.input-container2 {  \n  justify-content: center;\n  margin-bottom: 10px;\n}\n\n.input-container .input-group {\n  display: flex;\n  align-items: center;\n  margin-bottom: 5px;\n  margin-left: 10px;\n}\n\n.input-container label {\n  margin-right: 10px;\n}\n\n.input-container p {\n  margin: 0;\n}\n\n.section {\n  margin-bottom: 40px;\n}\n\n/* Blockchain Integration V2 Styles */\n.Json-resource-container {\n  margin: 20px;\n  padding: 20px;\n  border: 1px solid #ccc;\n  white-space: pre-wrap;\n  font-family: monospace;\n}\n\n.side-by-side {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.side-by-side2 {\n  display: inline-block;\n  margin-left: 5px;\n}\n\n.side-by-side-bnumber {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.square {\n  width: 70px;\n  height: 70px;\n  background-color: #f0f0f0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 24px;\n  font-weight: bold;\n  margin-left: 30px;\n}\n\n.small-heading {\n  font-size: small;\n}\n.red {\n  color: red;\n}\n.green {\n  color: green;\n}\n\n.container-bch {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 55vh; \n}\n\n/*Certification Manager */\n\n.container-CertificationManager {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.row-CertificationManager {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 10px;\n}\n\n.col-CertificationManager {\n  margin-right: 20px;\n  align-self: flex-start;\n}\n\n.label-CertificationManager {\n  font-weight: bold;\n}\n\n.select-input-CertificationManager {\n  width: 200px;\n}\n\n.add-button-CertificationManager {\n  margin-top: 10px;\n}\n\n.frame {\n  background-color: #f2f2f2;\n  border: 3px solid #007bff;\n  padding: 10px;\n  margin-top: 30px;\n  border-radius: 6px;\n}\n\n.frame-content {\n  background-color: #fff;\n  padding: 4px;\n  border-radius: 6px;\n  box-shadow: 0 2px 4px #007bff;\n}\n\n.red-status {\n  color: red;\n}\n.green-status {\n  color: green;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
